import { filter } from "lodash"
import { createSelector } from "reselect"

const getItems = props => props.items
const getOnly = props => props.onlyItem

export const getTotalItem = createSelector(
  [getItems],
  (items) => filter(items, (item) => !item.disabled && item.id === "positionsCount"),
)

export const getBreakdownItems = createSelector(
  [getItems],
  (items) => filter(items, (item) => !item.disabled && item.id !== "positionsCount"),
)

export const getOnlyLegendText = createSelector(
  [getOnly],
  (only) => only ? "All" : "Only",
)
